import { render, staticRenderFns } from "./PoliticaPrivacidade.vue?vue&type=template&id=202d2044&"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js&"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports